<!--
  @Description: 
  @Author: wang.y 
  @Date: 2022-02-17 
-->
<template>
  <div class="flow-list">
    <div class="flow-li" v-for="item,index in data" :key="index">
      <div :class="item.contentType == 3 ? 'flow-item2' : 'flow-item1'">
        <div class="tip" v-if="item.contentType == 4">快讯</div>
        <div class="img" v-else>
          <div class="tip" v-if="item.contentType == 0">文章</div>
          <div class="tip" v-if="item.contentType == 1">视频</div>
          <div class="tip" v-if="item.contentType == 2">报告</div>
          <div class="tip" v-if="item.contentType == 3">专题Pro</div>
          <i class="iconfont" v-if="item.contentType == 1" @click="goToDetail(item)">&#xe60f;</i>
          <img v-if="item.contentType != 4" class="theme-img" :src="item.logoPath | logo_show" @click="goToDetail(item)" />
        </div>
        <div class="cnt">
          <div class="title over-p2" @click="goToDetail(item)">{{item.title}}</div>
          <a :href="$store.state.index2_path + '/' + item.id" v-if="item.contentType == 0 || item.contentType == 1"></a>
          <a :href="$store.state.index_path + '/specialDetail/' + item.uid" v-if="item.contentType == 3"></a>
          <a :href="$store.state.index_path + '/reportDetail/' + item.uid" v-if="item.contentType == 2"></a>
          <a :href="$store.state.index2_path + '/newsDetail/' + item.uid" v-if="item.contentType == 4"></a>
          <div :class="item.contentType == 4 ? 'desc2' : 'desc'">
            <div class="type" v-if="item.entity_tag.length" @click="handleClickTag(item.entity_tag[0])">{{item.entity_tag[0].name}}</div>
            <div class="type" v-else></div>
            <div class="time" v-if="item.contentType == 3">{{item.sortTime | time_standard}}更新</div>
            <div class="time" v-else>{{item.publishTime | time_standard}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  created() { },
  mounted() { },
  props: ['data', 'colType'],
  data() {
    return {
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
  },
  methods: {
    //跳转至文章、视频。快讯、专题详情
    goToDetail(item) {
      switch (item.contentType) {
        case 0:
          const temp_href = this.$store.state.index2_path + '/' + item.id
          window.open(temp_href, '_blank')
          break;
        case 1:
          const temp_href1 = this.$store.state.index2_path + '/' + item.id
          window.open(temp_href1, '_blank')
          break
        case 3:
          const { href } = this.$router.resolve({ name: "SpecialDetail", params: { uid: item.uid } })
          window.open(href, '_blank')
          break;
        case 2:
          const { href2 } = this.$router.resolve({ name: "ReportDetail", params: { uid: item.uid } })
          window.open(href2, '_blank')
          break;
        case 4:
          const href3 = this.$store.state.index2_path + '/newsDetail/' + item.uid
          window.open(href3, '_blank')
          break;
      }
      if(this.colType == '1') {
        _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(动态信息流的标题)', '点击量'])
      }
      else if(this.colType == '2'){
        _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(动态信息流的标题)', '点击量'])
      }
      else if(this.colType == '3'){
        _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(动态信息流的标题)', '点击量'])
      }
      else if(this.colType == '4'){
        _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(动态信息流的标题)', '点击量'])
      }
    },
    handleClickTag(tag) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: tag.id } })
      window.open(href, '_blank')
      if(this.colType == '1') {
        _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(动态信息流的赛道标签)', '点击量'])
      }
      else if(this.colType == '2'){
        _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(动态信息流的赛道标签)', '点击量'])
      }
      else if(this.colType == '3'){
        _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(动态信息流的赛道标签)', '点击量'])
      }
      else if(this.colType == '4'){
        _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(动态信息流的赛道标签)', '点击量'])
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
.flow-list
  > div+div
    margin-top 20px
  .tip
    padding 0 6px
    display flex
    justify-content space-between
    align-items center
    height 18px
    background rgba(255, 136, 36, 0.8)
    font-size 12px
    color #FFFFFF
  .flow-item1, .flow-item2
    display flex
    .img
      width 108px
      height 68px
      font-size 0
      position relative
      overflow hidden
      .tip
        position absolute
        z-index 2
      img
        width 100%
        height 100%
        transition: all .5s
        &:hover
          transform: scale(1.1);
      .iconfont
        position absolute
        left 50%
        top 50%
        font-size 20px
        width 36px
        height 36px
        border-radius 50%
        background-color rgba(0, 0, 0, 0.5)
        display flex
        justify-content center
        align-items center
        color #fff
        transform translate(-50%, -50%)
        cursor pointer
        z-index 2
    .cnt
      flex 1
      margin-left 10px
      position relative
      .title
        font-size 14px
        line-height 18px
        cursor pointer
        transition all .5s
        &:hover
          color #FA5A00
      .desc
        position absolute
        bottom 0
        width 100%
      .desc2
        margin-top 6px
      .desc, .desc2
        font-size 12px
        display flex
        justify-content space-between
        line-height 1
        .type
          color #FA5A00
          cursor pointer
          transition all .5s
          &:hover
            color #FF4800
  .flow-item2
    display flex
    .img
      width 160px
      height 100px
.theme-img
  cursor pointer
</style>